var React = require('react');

function IconPulseInline (props) {
    return React.createElement("svg",props,React.createElement("polyline",{"stroke":"#000000","fill":"none","fillRule":"evenodd","strokeLinecap":"square","strokeLinejoin":"round","strokeWidth":"4","points":"5 24 13 24 20 8 28 40 35 24 43 24"}));
}

IconPulseInline.defaultProps = {"width":"1em","height":"1em","fill":"#000000","viewBox":"0 0 48 48"};

module.exports = IconPulseInline;

IconPulseInline.default = IconPulseInline;
